
import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import Footer from "@/components/Footer";
import { WalletButton } from "@/wallet";

const OceanOutlawFund = () => {
  return (
    <div className="min-h-screen bg-[#0B0F1A] text-[#ECECEC] font-mono">
      {/* Hero Section */}
      <section 
        className="relative min-h-[60vh] flex items-center justify-center text-center p-8"
        style={{
          background: `linear-gradient(to bottom, rgba(11,15,26,0.7) 0%, rgba(11,15,26,0.9) 100%), 
                      url('https://images.unsplash.com/photo-1518877593221-1f28583780b4?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80') center/cover no-repeat`
        }}
      >
        <div>
          <h1 className="text-4xl md:text-5xl text-[#FF8C3C] mb-2">
            Ocean Outlaw Fund
          </h1>
          <p className="text-xl max-w-xl mx-auto">
            Turning every $POP swap into direct-to-sea rescue—no virtue signaling, no middlemen.
          </p>
        </div>
      </section>

      {/* Mission & How It Works */}
      <section className="py-16 px-4 bg-[#1F2228]">
        <div className="container mx-auto">
          <h2 className="text-3xl md:text-4xl text-[#FF6F1E] mb-4">
            Our Mission
          </h2>
          <p className="max-w-3xl mb-8 text-lg">
            The Ocean Outlaw Fund is our on-chain rescue crew—funded by 2% of every PopCoin trade—to clean plastic, patch oil slicks, and save marine life from the brink.
          </p>

          <h3 className="text-2xl md:text-3xl text-[#FF8C3C] mb-4">
            How It Works
          </h3>
          <ul className="list-none p-0 max-w-2xl mx-auto space-y-6">
            <li className="flex items-start">
              <div className="text-4xl w-12 text-[#FF6F1E] flex-shrink-0">💧</div>
              <div className="ml-4">
                <strong className="text-lg">2% Tax Allocation</strong><br />
                Automatically siphoned from each PopCoin swap into the Fund.
              </div>
            </li>
            <li className="flex items-start">
              <div className="text-4xl w-12 text-[#FF6F1E] flex-shrink-0">🔗</div>
              <div className="ml-4">
                <strong className="text-lg">Direct on-chain Treasury</strong><br />
                Held in a transparent wallet—no boardroom, no BS.
              </div>
            </li>
            <li className="flex items-start">
              <div className="text-4xl w-12 text-[#FF6F1E] flex-shrink-0">🌊</div>
              <div className="ml-4">
                <strong className="text-lg">Quarterly Payouts</strong><br />
                Smart-contract disbursements to vetted marine NGOs, with public proof of impact.
              </div>
            </li>
          </ul>
        </div>
      </section>

      {/* Impact Stats */}
      <section className="py-16 px-4">
        <div className="container mx-auto">
          <h2 className="text-3xl md:text-4xl text-[#FF6F1E] mb-8 text-center">
            Fund Impact So Far
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="bg-[#1F2228] p-6 rounded-lg text-center">
              <h3 className="text-4xl text-[#FF8C3C] font-bold">12,345&nbsp;kg</h3>
              <p className="mt-2">Plastic Removed</p>
            </div>
            <div className="bg-[#1F2228] p-6 rounded-lg text-center">
              <h3 className="text-4xl text-[#FF8C3C] font-bold">4,567&nbsp;L</h3>
              <p className="mt-2">Oil Slicks Cleaned</p>
            </div>
            <div className="bg-[#1F2228] p-6 rounded-lg text-center">
              <h3 className="text-4xl text-[#FF8C3C] font-bold">89&nbsp;Lives</h3>
              <p className="mt-2">Marine Animals Rescued</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 px-4 bg-[#3F2A1A] text-center">
        <div className="container mx-auto">
          <h2 className="text-3xl md:text-4xl text-[#FF8C3C] mb-6">
            Ready to join the revolt?
          </h2>
          <div className="flex justify-center">
            <WalletButton 
              size="lg"
              className="bg-gradient-to-r from-[#FF6F1E] to-[#FF8C3C] text-[#0B0F1A] hover:opacity-90 px-8 py-6 text-xl"
            />
          </div>
        </div>
      </section>

      <div className="container mx-auto px-4 py-8">
        <Link to="/whitepaper">
          <Button variant="outline" className="border-orange-500/20 hover:border-orange-500/60 hover:bg-orange-500/10 text-gray-300">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to White Paper
          </Button>
        </Link>
      </div>
      
      <Footer />
    </div>
  );
};

export default OceanOutlawFund;
